import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchInvoicePdf, invoiceService } from "../services/get-invoices";

export default function useInvoices({
  page,
  search,
  filter,
}: {
  page: number;
  search?: string;
  filter?: string;
}) {
  const normalizedSearch = search?.trim() || undefined;
  const normalizedFilter = filter || undefined;

  return useQuery({
    queryKey: ["invoices", { page, normalizedSearch, normalizedFilter }],
    queryFn: () =>
      invoiceService.getInvoices({
        page,
        search: normalizedSearch,
        filter: normalizedFilter,
      }),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
export function useInvoicePdf() {
  return useMutation({
    mutationFn: (id: string) => fetchInvoicePdf(id),
  });
}